import axiosInstance from "@/api/axios-instance";
import { FormSubmissionDailyCount } from "@/pages/forms/types/form";

export async function getFormSubmissionStats(
  id: string,
  days = 7,
): Promise<FormSubmissionDailyCount[]> {
  const response = await axiosInstance.get(`/forms/${id}/submissions/daily`, {
    params: { days },
  });
  return response.data as FormSubmissionDailyCount[];
}
